var React = require('react');

function BackArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M15 18L9 12L15 6","stroke":"#0BCE5A","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"}));
}

BackArrow.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = BackArrow;

BackArrow.default = BackArrow;
